jQuery(function ($) {

    // -----------------------
    // Format titles
    // -----------------------

    $(".accs-sel-wrapper .title").each(function () {

        let html = $(this).html();

        if (html.includes("title-sub")) return;

        $(this).html(
            html.replace(" (", '<br><span class="title-sub">(') + "</span>"
        );

    });



    // -----------------------
    // Helpers
    // -----------------------



    function clearAccessories() {

        $(".accs-sel-wrapper input")
            .prop("checked", false);

    }


    function showAccessories($item) {

        const productId = $item.attr("data-product-id");
        const handler = $item.attr("data-click-handler");

        $(".accs-sel-wrapper label").addClass("hide");

        // Show individual accessories
        $(".accs-sel-wrapper label[data-product-id='" + productId + "']")
            .removeClass("hide");

        // Show bundles
        $(".accs-sel-wrapper label[data-click-handler='" + handler + "']")
            .removeClass("hide");

    }

    // -----------------------
    // Vacuum Model
    // -----------------------

    $(".select-wrapper .item").on("click", function () {

        const $this = $(this);

        

        $(".select-wrapper .item")
            .removeClass("active");

        $this.addClass("active");

        showAccessories($this);

        const title = $this.attr("data-product-title");

        let handler = "nanobot";

        if (title.includes("Elite")) {
            handler = "nanobot-elite";
        } else if (title.includes("Pro")) {
            handler = "nanobot-pro";
        }

        // Hide only bundle labels
        $('.accs-sel-wrapper label[data-click-handler]')
            .addClass("hide");

        // Show matching bundle labels
        $('.accs-sel-wrapper')
            .removeClass('nanobot nanobot-pro nanobot-elite')
            .addClass(handler);

        $('.accs-sel-wrapper label[data-click-handler="' + handler + '"]')
            .removeClass("hide");

        const $first = $('.accs-sel-wrapper label[data-click-handler="' + handler + '"]')
            .first();

        $first.find("input")
            .prop("checked", true)
            .trigger("change");

        $(".product-restocks p b")
            .text($this.attr("data-product-stock"));

        $("#initateCheckout")
            .text($this.attr("data-product-atc"));

        $(".product-single__meta .main")
        .text((title || "").replace(/^PRISM\+\s*/i, ""));

        $("#currentSelection")
            .attr(
                "data-stocknum",
                $this.attr("data-product-indicator")
            );


        updateStockIndicator();

        

    });

    // -----------------------
    // Accessory Selected
    // -----------------------

    $(".accs-sel-wrapper input").on("change", function () {

        const $this = $(this);

        clearAccessories();

        $this.prop("checked", true);

        

        $("#currentSelection")
            .attr("data-variant", $this.val())
            .attr("data-price", $this.attr("data-price"))
            .attr("data-stocknum", $this.attr("data-stock-indicator"))
            .attr("data-bundled-variant-ids", $this.attr("data-bundled-variants") || "")
            .attr("data-restock", $this.attr("data-restock"));

        $(".product-single__thumbnails-items")
            .removeClass("main")
            .addClass("hide");

        $(".product-single__thumbnails-items." + $this.attr("data-handle"))
            .addClass("main")
            .removeClass("hide");

        $(".product-single__thumbnails-items." + $this.attr("data-handle") + " a")
            .addClass("active-thumb");

        $(".subtitle[data-variant_title]")
            .html($this.attr("data-variant_title") || "");

        //const url = new URL(window.location.href);

        //url.pathname = "/products/" + $this.attr("data-product_handle");
        //url.searchParams.set("variant", $this.val());

        //window.history.replaceState(null, "", url.toString());

        const handle = $this.attr("data-product_handle");
        if (handle && handle.includes("bundle")) {
          console.log('selected handle:'+handle);

          $(".product-single__thumbnails-items")
              .removeClass("main")
              .addClass("hide");

          $(".product-single__thumbnail")
              .removeClass("active-thumb");

          const $thumb = $(".product-single__thumbnails-items." + handle);

          $thumb
              .removeClass("hide")
              .addClass("main");

          $thumb.find("a")
              .addClass("active-thumb");
        }

        updateLinks();
        updatePrice();
        updateInstallment();
        updateThumbnail();

    });

    setTimeout(function () {
        $(".select-wrapper .item.active").trigger("click");
    }, 100);
});